import { setShowFolderPane, setShowFolderPaneAsTransientOverlay } from 'owa-mail-layout';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

export function showFolderPaneFromSideRail(): void {
    if (isWin32StylingEnabled()) {
        setShowFolderPaneAsTransientOverlay(true);
        return;
    }

    setShowFolderPane(true);
}

export function hideFolderPaneAfterSideRailInteraction(): void {
    if (isWin32StylingEnabled()) {
        setShowFolderPaneAsTransientOverlay(false);
        return;
    }

    setShowFolderPane(false);
}
